import { render, staticRenderFns } from "./course-loading.vue?vue&type=template&id=d35f5aae&"
import script from "./course-loading.vue?vue&type=script&lang=js&"
export * from "./course-loading.vue?vue&type=script&lang=js&"
import style0 from "./course-loading.vue?vue&type=style&index=0&id=d35f5aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports